import {
    StackerAPI,
    StackerActions,
    FETCH_STARTED,
    FETCH_COMPLETED,
    fetchAndReturn,
    byID,
    without,
} from "./utils/utils"
import { OBJECTS_FETCHED, FIELDS_FETCHED } from "./objectApi"
import { APPS_FETCHED } from "./appApi"
import { PAGES_FETCHED } from "./pageApi"
import { groupBy } from "utils/utils"
import { STACK_SELECTED } from "./stackApi"

import deepcopy from "deepcopy"

// CONSTANTS
export const RECORDS_FETCHED = "RECORDS_FETCHED"
export const RECORD_CREATED = "RECORD_CREATED"
export const RECORD_UPDATED = "RECORD_UPDATED"
export const RECORD_REMOVED = "RECORD_REMOVED"

// API
class RecordApi extends StackerAPI {
    path = "records/"

    getObjectRecords(objectId) {
        let path
        if (["app", "page", "object", "field"].indexOf(objectId) !== -1) {
            path = objectId + "s/"
        } else {
            path = "objects/" + objectId + "/records/"
        }

        return fetchAndReturn(path, {})
    }
}
const recordApi = new RecordApi()

class RecordActions extends StackerActions {
    api = recordApi
    reducer = "records"
    actionTypes = {
        fetched: RECORDS_FETCHED,
        removed: RECORD_REMOVED,
        created: RECORD_CREATED,
        updated: RECORD_UPDATED,
    }
    fetchByObject = id => {
        return dispatch => {
            this.api.getObjectRecords(id).then(response => {
                return dispatch({ type: this.actionTypes.fetched, payload: response })
            })
        }
    }
}
let RA = new RecordActions()
RA.actions = { ...RA.actions, fetchByObject: RA.fetchByObject }
export const recordActions = RA.actions

// STATE
const initialState = {
    records: {},
    entities: {},
    fetching: [],
}

// REDUCERS
export function recordReducer(state = initialState, action) {
    var records, record, recordList, fetching
    switch (action.type) {
        case RECORDS_FETCHED:
            // payload = action.id ? [action.payload] : action.payload
            if (Array.isArray(action.payload)) {
                records = groupRecordIDsByObjectId(action.payload)
                recordList = action.payload
            } else {
                records = {}
                recordList = [action.payload]
            }
            return {
                ...state,
                records: { ...state.records, ...records },
                entities: { ...state.entities, ...byID(recordList) },
            }
        case RECORD_CREATED:
            records = {
                ...state.records,
                [action.payload._object_id]: [
                    ...(state.records[action.payload._object_id] || []),
                    action.payload._sid,
                ],
            }
            return {
                ...state,
                records,
                entities: { ...state.entities, [action.payload._sid]: action.payload },
            }
        case RECORD_UPDATED:
            record = { ...state.entities[action.id], ...action.payload }
            return {
                ...state,
                entities: { ...state.entities, [record._sid]: record },
            }
        case RECORD_REMOVED:
            records = deepcopy(state.records)

            Object.keys(records).forEach(recordKey => {
                records[recordKey] = records[recordKey].filter(id => id !== action.id)
            })
            return {
                ...state,
                records,
            }

        case FETCH_STARTED:
            return { ...state, fetching: [...state.fetching, action.key] }
        case FETCH_COMPLETED:
            fetching = state.fetching.filter(item => item !== action.key)
            return { ...state, fetching: fetching }

        // Here, we also load in all our metadata and group by their fake "object id"
        // So that we can basically treat them the same as normal data for e.g. lookups
        case OBJECTS_FETCHED:
            // payload = action.id ? [action.payload] : action.payload
            records = { object: action.payload.map(item => item._sid) }
            return {
                ...state,
                records: { ...state.records, ...records },
                entities: { ...state.entities, ...byID(action.payload) },
            }
        case PAGES_FETCHED:
            // payload = action.id ? [action.payload] : action.payload
            records = { page: action.payload.map(item => item._sid) }
            return {
                ...state,
                records: { ...state.records, ...records },
                entities: { ...state.entities, ...byID(action.payload) },
            }
        case APPS_FETCHED:
            // payload = action.id ? [action.payload] : action.payload
            records = { app: action.payload.map(item => item._sid) }
            return {
                ...state,
                records: { ...state.records, ...records },
                entities: { ...state.entities, ...byID(action.payload) },
            }
        case FIELDS_FETCHED:
            // payload = action.id ? [action.payload] : action.payload
            records = { field: action.payload.map(item => item._sid) }
            return {
                ...state,
                records: { ...state.records, ...records },
                entities: { ...state.entities, ...byID(action.payload) },
            }
        case STACK_SELECTED:
            return initialState
        default:
            return state
    }
}

// SELECTORS
export const getRecordEntities = state => state.records.entities
export const getRecordsMap = state => {
    let recordsMap = {}
    Object.keys(state.records.records).forEach(oId => {
        let records = state.records.records[oId].map(id => state.records.entities[id])
        recordsMap[oId] = records
    })
    return recordsMap
}

// HELPERS

const groupRecordIDsByObjectId = records => {
    if (!records) return {}
    let recordsByObj = groupBy(records || [], "_object_id")
    Object.keys(recordsByObj).forEach(objId => {
        recordsByObj[objId] = recordsByObj[objId].map(record => record._sid)
    })
    return recordsByObj
}



// WEBPACK FOOTER //
// ./src/data/recordApi.js